import { useQueryIntegrationOnboardingSessions } from '@/hooks/query/integrations/general/onboarding-session/useQueryIntegrationOnboardingSessions';
import { resolveOnboardingProvider } from '@heidi/integrations/ehr/data';
import { EHRProvider, OnboardingSessionStatus } from '@heidi/schema/ml-scribe';
import { useMemo } from 'react';

const LEGACY_PROVIDERS: EHRProvider[] = [
  EHRProvider.Best_Practice,
  EHRProvider.Cliniko,
  EHRProvider.Magentus,
  EHRProvider.Mindbody,
  EHRProvider.Epic_Systems,
];

export const useOldFrameworkIntegrations = () => {
  const { data: integrationOnboardingSessions } = useQueryIntegrationOnboardingSessions({
    params: {
      status: OnboardingSessionStatus.completed,
    },
    select: (data) => data.sessions,
  });

  return useMemo(() => {
    const integrationOnboardingProviderSet = new Set(
      integrationOnboardingSessions?.map((session) => session.provider)
    );

    // A legacy provider may have been migrated to the new framework under a
    // *different* provider name (this happened with Magentus -> Gentu). Resolve to the
    // new-framework provider before checking membership, so a migrated provider
    // is no longer treated as old-framework once its onboarding session exists.
    return LEGACY_PROVIDERS.filter(
      (provider) =>
        !integrationOnboardingProviderSet.has(resolveOnboardingProvider(provider))
    );
  }, [integrationOnboardingSessions]);
};
